import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            localSettingsReceived: 'localSettings/LocalSettings',
        }),
    },
    methods: {
        ...mapActions({
            FetchLocalSettings: 'localSettings/FetchLocalSettings',
        }),
        GetLocalSetting(key) { return this.localSettings?.keyValuePairs[key] || null; },
        LoadLocalSettings() {
            eventBus.$emit('local-settings-fetch:started');
            this.FetchLocalSettings()
                .then(() => {
                    this.localSettings = Object.assign({}, this.localSettingsReceived);
                    eventBus.$emit('local-settings-fetch:success');
                })
                .catch(error => eventBus.$emit('console:error', error))
                .finally(() => eventBus.$emit('local-settings-fetch:finished'));
        },
    },
};